import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';

export const LANGUAGES = ['es', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];

const STORAGE_KEY = 'syncra.lang';

function readSaved(): Language | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'es' || v === 'en' ? v : null;
  } catch {
    return null;
  }
}

function save(lang: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* per-viewer preference only */
  }
}

/** Saved choice → browser language (es* → es) → English. */
export function detectLanguage(): Language {
  const saved = readSaved();
  if (saved) return saved;
  const nav = typeof navigator !== 'undefined' ? navigator.language : '';
  return nav.toLowerCase().startsWith('es') ? 'es' : 'en';
}

export const resources = { en: { translation: en }, es: { translation: es } } as const;

export function initI18n(lng: Language = detectLanguage()) {
  if (!i18n.isInitialized) {
    void i18n.use(initReactI18next).init({
      resources,
      lng,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
      returnNull: false
    });
    i18n.on('languageChanged', (l) => {
      save(l);
      if (typeof document !== 'undefined') document.documentElement.lang = l;
    });
    if (typeof document !== 'undefined') document.documentElement.lang = lng;
  }
  return i18n;
}

export default i18n;
